import { LARGE_DESKTOP_CONT_WIDTH, MEDIUM_DESKTOP_CONT_WIDTH } from "pazChargeComponents/Home/HomePageCharge";
import { Container } from "ui";

type Props = {
    children: React.ReactNode;
    withoutPadding?: boolean
}
export default function ContainerWrapper({ children, withoutPadding = false }: Props) {
    return (
        <Container
            largeDesktopWidth={LARGE_DESKTOP_CONT_WIDTH}
            mediumDesktopWidth={MEDIUM_DESKTOP_CONT_WIDTH}
            withoutPadding={withoutPadding}
        >
            {children}
        </Container>
    )
}
